import React, {useEffect, useState} from 'react';
import './seleciona-nfe.scss';
import {Col, Row,  Button, Space} from 'antd';
import {useAxios} from "../../../../hooks/use-axios";
import {NFeListItem} from './nfe-list-item';
import { BuscadorLateral } from '../../../../componentes';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt } from '@fortawesome/pro-duotone-svg-icons';




const useNFe = () => {
    const {getApiEmitirNotas} = useAxios();

    const buscaNotasNaoProcessadas = async (
        setLoading = (arg) => {},
        setNotas = (arg) => {}) => {
        setLoading(true);
        const axios = await getApiEmitirNotas();
        try{
            const response = await axios.get('/fiscal/nfe-contra/fora-estoque');
            setNotas(response.data);
            console.log(response.data);
            
        } catch(e) {
            console.log(e)
        } finally {
            setLoading(false);

        }

        return;
        

    }

    const buscaNFeSefaz = async (filtro, setLoading) => {
        const axios = await getApiEmitirNotas();
        const result = await axios.post('/fiscal/nfe-contra/'+ filtro + '/download');
        setLoading(false);
        return result
    }

    return {buscaNotasNaoProcessadas, buscaNFeSefaz};

}

const SelecionaNFe = (props) => {

    const {buscaNotasNaoProcessadas, buscaNFeSefaz} = useNFe();    
    const [notas, setNotas] = useState([]);
    const [notasFiltradas, setNotasFiltradas] = useState([]);
    const [filtro, setFiltro] = useState('');
    const [loadingBuscaNotas, setLoadingBuscaNotas] = useState(false);
    const [loadingDownloadNFe,setLoadingDownloadNFe] = useState(false);
    const [nfeSelecionada, setNFeSelecionada] = useState({});
    const [notasRendered, setNotasRendered] = useState([]);

    const { aoSelecionarNFe , registraRecarregaNFeListener} = props;

    useEffect(() => {
        const notasRendered = [];
        notasFiltradas.forEach((nota) => {
            const selecionada = (nota.uuid === nfeSelecionada.uuid);
            console.log('selecionada', selecionada);
            notasRendered.push(<NFeListItem key={nota.chaveNFe} nfe={nota} selecionada={selecionada} onClick={onSelecionaNFe(nota)}></NFeListItem>);
        });

        if(notasFiltradas.length === 0 ){
            notasRendered.push(renderizaSugestaoBusca())
        }

        setNotasRendered(notasRendered);

    }, [notasFiltradas]);

    const selecionaNFe = (nfe)=>{
        setNFeSelecionada(nfe);
        aoSelecionarNFe(nfe);
    }

    const filtrarNotas = function(){
        const uuidNFeSelecionada = nfeSelecionada.uuid || "";
        const novaLista = notas.filter(nota => 
            (nota.chaveNFe.indexOf(filtro) >=0 || !filtro) 
        );
        setNotasFiltradas(novaLista);

        if(uuidNFeSelecionada){
            const busca = novaLista.filter(nota => nota.uuid === uuidNFeSelecionada);
            if(busca.length){
                selecionaNFe(busca[0]);
            } else {
                selecionaNFe({});
            }
        } else{
            selecionaNFe({});
        }
        // selecionaNFe({});
        
    }
    
    const recarregar = async () => {
        
        await buscaNotasNaoProcessadas(setLoadingBuscaNotas, setNotas);

        
        // filtrarNotas();
       
        // setNotasFiltradas(notas);
    }

    useEffect(() => {
        filtrarNotas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[notas])
    
    
    useEffect(() => {
        recarregar();
        registraRecarregaNFeListener(recarregar);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSelecionaNFe = (nfe) => {
        return (evt) => {
            aoSelecionarNFe(nfe);
            setNFeSelecionada(nfe);
        }
    }

    const buscaNFeSefazHandler = async () => {
        await buscaNFeSefaz(filtro, setLoadingDownloadNFe);
        setFiltro('');
        recarregar();
    }

   const renderizaSugestaoBusca = () => {
       const renderizaBotaoBusca = () => {
           return (<Button type="primary" onClick={buscaNFeSefazHandler} loading={loadingDownloadNFe}>Buscar No Sefaz</Button>)
       }

       const renderizaAvisoChaveInvalida = (validacaoChave) => {
            return (<div>
                A chave da nota é inválida! É esperado {JSON.stringify(validacaoChave.esperado)}
            </div>)
       }

       const validacaoChave = () => {
           if(!filtro || filtro.length !== 44){
               return {
                   esperado: "44 digitos para uma chave",
                   valida: false
               }
           } 
           const arrFiltro = filtro.split("");
           const arrPesos = [4,3,2,9,8,7,6,5,4,3,2,9,8,7,6,5,4,3,2,9,8,7,6,5,4,3,2,9,8,7,6,5,4,3,2,9,8,7,6,5,4,3,2];
           const produto = arrFiltro.reduce((anterior, atual, indice) => {
               if(indice < 43)
                return (arrPesos[indice] * parseInt(atual)) + anterior;

               return anterior;
            }, 0 );
           
           if(isNaN(produto)){
               return {
                   esperado: "que a contenha apenas numeros",
                   valida: false
               }
           }
           const modulo = (produto % 11);
           let dv = 0;
           if(modulo > 1){
                dv = 11 - modulo;
           }

           if(dv == filtro.substr(filtro.length -1, 1)){
               return {
                   valida: true
               }
           } else {
               return {
                   valida: false,
                   esperado: filtro.substr(0, 43) + dv + ""
               }
           }

       }

       const renderizaBotaoOuAviso = () => {
           const validacao = validacaoChave();
           if(validacao.valida){
               return renderizaBotaoBusca();
           } else {
               return renderizaAvisoChaveInvalida(validacao)
           }
       }
       if(filtro && filtro.length > 0){

        return (<Space direction="vertical">
            
                <Row>
                    <Col style={{
                        fontSize: "0.8rem"
                    }} span={24}>
                        Deseja Buscar no sefaz pela chave [{filtro}]?
                    </Col>

                
                </Row>
                <Row>
                    <Col span={24} style={{
                        textAlign: "center"
                    }}>
                        {renderizaBotaoOuAviso()}
                    </Col>
                </Row>
        </Space>)
       } else {
           return (<></>);
       }
    }

    

   

    
    
    useEffect(()=>{
        filtrarNotas();
    }, [filtro])
    
    const changeFiltroNFeHandler = (evt) => {
        console.log(evt);
        setFiltro(evt.target.value);
        // filtrarNotas();
        
    }

    

    return (
        <BuscadorLateral
            search={{
                onSearch:recarregar, 
                placeholder: "Chave NFe Entrada",
                loading:loadingBuscaNotas,
                enterButton: (<FontAwesomeIcon icon={faRedoAlt}></FontAwesomeIcon>),
                onChange: changeFiltroNFeHandler
            }}
            key={`itens_${notasRendered.length}`}
            items={notasRendered}
        >
        </BuscadorLateral>
    

    );
   
}

export {SelecionaNFe};